import { Link } from "react-router-dom";
function HW3LandingPage() {
    return(
        <div className="container-fluid">
            <h4>
                Welcome to Cob's Soulo Game!
            </h4>
            <nav>
                <Link to="/DarkLogin">Dark Login</Link>
                <Link to="/Login">Login</Link>
            </nav>
        </div>
    )
}

export default HW3LandingPage;